var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.showSiteChrome)?_c('AppHeader'):_vm._e(),_c('router-view'),(_vm.showSiteChrome)?_c('AppFooter'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }